// extracted by mini-css-extract-plugin
module.exports = {"testimony":"styles-module--testimony--ny7Gp"};